"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.azPetVetTypography = void 0;
var common = __importStar(require("../../shared/typography"));
exports.azPetVetTypography = [
    {
        props: common.heroXL.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroXLCommon), { fontFamily: 'Lato', fontWeight: 900, fontSize: '7rem', lineHeight: '6.75rem', letterSpacing: '-1px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '4rem',
                    lineHeight: '4.25rem',
                    letterSpacing: 0,
                } }));
        },
    },
    {
        props: common.heroLarge.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroLargeCommon), { fontFamily: 'Lato', fontWeight: 900, fontSize: '4rem', lineHeight: '5rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '4rem',
                    lineHeight: '4.25rem',
                    letterSpacing: 0,
                } }));
        },
    },
    {
        props: common.heroMedium.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroMediumCommon), { fontFamily: 'Lato', fontWeight: 900, fontSize: '3.5rem', lineHeight: '3.75rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '3.5rem',
                    lineHeight: '3.75rem',
                    letterSpacing: 0,
                } }));
        },
    },
    {
        props: common.header1.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header1Common), { fontFamily: 'Lato', fontWeight: 900, fontSize: '3.5rem', lineHeight: '3.75rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '2.25rem',
                    lineHeight: '2.5rem',
                } }));
        },
    },
    {
        props: common.header2.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header2Common), { fontFamily: 'Lato', fontWeight: 900, fontSize: '2.25rem', lineHeight: '2.5rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.625rem',
                    lineHeight: '1.75rem',
                } }));
        },
    },
    {
        props: common.header3.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header3Common), { fontFamily: 'Lato', fontWeight: 700, fontSize: '2rem', lineHeight: '2.25rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.375rem',
                    lineHeight: '1.5rem',
                } }));
        },
    },
    {
        props: common.header4.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header4Common), { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.625rem', lineHeight: '1.75rem', letterSpacing: 0, color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.25rem',
                    lineHeight: '1.375rem',
                } }));
        },
    },
    {
        props: common.badgeLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.badgeLabelCommon), { fontFamily: 'Lato', fontWeight: 400, fontSize: '0.75rem', lineHeight: '1rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyXLBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyXLBookCommon), { fontFamily: 'Lato', fontWeight: 400, fontSize: '1.375rem', lineHeight: '1.75rem', letterSpacing: 0, fontStyle: 'normal', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeBookCommon), { fontFamily: 'Lato', fontSize: '1.125rem', fontWeight: 400, lineHeight: '1.75rem', fontStyle: 'normal', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeSemiBoldCommon), { fontFamily: 'Lato', fontSize: '1.125rem', fontWeight: 700, lineHeight: '1.75rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeBoldCommon), { fontFamily: 'Lato', fontSize: '1.125rem', fontWeight: 900, lineHeight: '1.75rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBookCommon), { fontFamily: 'Lato', fontSize: '1rem', fontWeight: 400, lineHeight: '1.5rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumSemiBoldCommon), { fontFamily: 'Lato', fontSize: '1rem', fontWeight: 700, lineHeight: '1.5rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBoldCommon), { fontFamily: 'Lato', fontSize: '1rem', fontWeight: 900, lineHeight: '1.5rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallBookCommon), { fontFamily: 'Lato', fontSize: '0.875rem', fontWeight: 400, lineHeight: '1.25rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallSemiBoldCommon), { fontFamily: 'Lato', fontSize: '0.875rem', fontWeight: 700, lineHeight: '1.25rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallBoldCommon), { fontFamily: 'Lato', fontSize: '0.875rem', fontWeight: 900, lineHeight: '1.25rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.captionLarge.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionLargeCommon), { fontFamily: 'Lato', fontWeight: 400, fontSize: '1rem', lineHeight: '1.25rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.captionMedium.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionMediumCommon), { fontFamily: 'Lato', fontWeight: 400, fontSize: '0.875rem', lineHeight: '1rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.chipLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.chipLabelCommon), { fontFamily: 'Lato', fontWeight: 400, fontSize: '0.875rem', fontStyle: 'normal', lineHeight: '1.25rem', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.errorValidation.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.errorValidationCommon), { fontFamily: 'Lato', fontWeight: 400, letterSpacing: 0, fontSize: '0.75rem', lineHeight: '1rem', color: theme.palette.error.dark }));
        },
    },
    {
        props: common.buttonLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.buttonCommon), { fontFamily: 'Lato', fontWeight: 700, textTransform: 'none', fontSize: '1rem', lineHeight: '1.25rem', color: theme.palette.text.secondary }));
        },
    },
    {
        props: common.overline.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.overlineCommon), { fontFamily: 'Lato', fontWeight: 400, letterSpacing: '1px', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.assistiveText.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Lato',
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: '1rem',
                letterSpacing: 0,
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
    {
        props: common.lowestLevelBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelBookCommon), { fontFamily: 'Lato', fontSize: '0.75rem', fontWeight: 400, lineHeight: '1rem', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelSemiBoldCommon), { fontFamily: 'Lato', fontSize: '0.75rem', fontWeight: 700, lineHeight: '1rem', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelBoldCommon), { fontFamily: 'Lato', fontSize: '0.75rem', fontWeight: 900, lineHeight: '1rem', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.mainNavigationDefault.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Lato',
                fontSize: '0.75rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                letterSpacing: '0.031rem',
                textTransform: 'uppercase',
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
    {
        props: common.mainNavigationDefaultSubCategory.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Lato',
                fontSize: '0.75rem',
                fontWeight: 700,
                lineHeight: '1rem',
                letterSpacing: '0.063rem',
                textTransform: 'uppercase',
                fontStyle: 'normal',
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
    {
        props: common.mainNavigationLight.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Lato',
                fontWeight: 400,
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                letterSpacing: 0,
                fontStyle: 'normal',
                color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
            });
        },
    },
    {
        props: common.notification.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Lato',
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                fontWeight: 400,
                letterSpacing: 0,
                fontStyle: 'normal',
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
];
